export const formSubmitValueMapper = (data = {}) => ({
  tgl_close_produksi_aset: data?.tgl_close_produksi_aset,
  id_produksi_aset: data?.id_produksi_aset,
});
